import { Stack, Typography } from '@mui/material'
import { CompanyVisit } from 'services/api/endpoints/risikaAPI/companyVisitsList'
import { padding } from './columns.styles'

type Props = {
  item: CompanyVisit
}

function Status({ item }: Props) {
  return (
    <Stack sx={padding}>
      <Typography color="grey.800" variant="body2">
        {item.status}
      </Typography>
    </Stack>
  )
}

export default Status
